class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForms: '[action="/cart/add"]:not(.ctl-product-form [action="/cart/add"], .GWP-global-wrapper [action="/cart/add"], .GWP-collection-wrapper [action="/cart/add"], .GWP-product-wrapper [action="/cart/add"])',
      giftGlobalForm: '.GWP-global-wrapper [action="/cart/add"]',
      giftCollectionForm: '.GWP-collection-wrapper [action="/cart/add"]',
      giftProductForm: '.GWP-product-wrapper [action="/cart/add"]',
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      removeButtons: '.cart .items-wrapper .item .remove-item',
      removeAddOnButtons: '.cart .items-wrapper .item .remove-add-on',
      quantitySelectorPlus: '.cart .items-wrapper .item .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .item .quantity-wrapper .minus',
      cartCount: '.cart-count'
    }

    this.init();
  }

  init() {
    window.log("Initialising global QF listeners");
    let vm = this;
    document.body.addEventListener('click', function (e) {
      vm.productQuickAdd(e)
      vm.siteCart(e)
      vm.quantityButtons(e)
      vm.removeCartItem(e)
      vm.removeCartItemAddOn(e)
    })
    vm.productForm()
    vm.gwpGlobalForm()
    vm.gwpCollectionForm()
    vm.gwpProductForm()
    vm.cartRelated()
    vm.headerSearch()
    vm.mobileMenu()
    vm.stickyHeader()
  }

  productQuickAdd(e) {
    // PRODUCT QUICK ADD
    const quickAdd = e.target.closest(this.selectors.quickAdds);
    if (quickAdd) {
      if (quickAdd.dataset.id && quickAdd.dataset.quantity && quickAdd.dataset.quantity > 0) {
        window.cart.add({ items: [{ "id": quickAdd.dataset.id, "quantity": quickAdd.dataset.quantity }] });
      }
    }
  }

  // BASE PRODUCT FORM LISTENER
  productForm() {
    let productForms = document.querySelectorAll(this.selectors.productForms);
    for (let i = 0; i < productForms.length; i++) {
      let productForm = productForms[i];
      
      productForm.addEventListener("submit", function (e) {
        e.preventDefault();
        let submitBtn = productForm.querySelector('input[type="submit"');
        let quantity = productForm.querySelector("input.quantity-selector").value;
        let id = productForm.querySelector("#product-id").value;
        
        if (quantity && id) {
          submitBtn.value = "Adding to cart"
          window.cart.add({ items: [{ "id": id, "quantity": quantity }] }).then(()=>submitBtn.value = "Add to cart");
        }
      });
    }
  }

  // GWP GLOBAL FORM LISTENER
  gwpGlobalForm() {
    let giftGlobalForm = document.querySelectorAll(this.selectors.giftGlobalForm);
    for (let i = 0; i < giftGlobalForm.length; i++) {
      let gwpGlobalForm = giftGlobalForm[i];
      
      gwpGlobalForm.addEventListener("submit", function (e) {
        e.preventDefault();
        let submitBtn = gwpGlobalForm.querySelector('input[type="submit"');
        let quantity = gwpGlobalForm.querySelector("input.quantity-selector").value;
        let id = gwpGlobalForm.querySelector("#product-id").value;
        
        if (quantity && id) {
          submitBtn.value = "Adding to cart"
          window.cart.add({ items: [{ "id": id, "quantity": quantity, properties: {'Free Gift': true, 'global_property': true} }] }).then(()=>submitBtn.value = "Add to cart");
        }

        document.querySelector(".GWP-global-wrapper").classList.add("hidden");
        submitBtn.setAttribute("disabled", "");
        setTimeout(function(){
          location.reload();
        }, 1000);
      });
    }
  }

  // GWP COLLECTION FORM LISTENER
  gwpCollectionForm() {
    let giftCollectionForm = document.querySelectorAll(this.selectors.giftCollectionForm);
    for (let i = 0; i < giftCollectionForm.length; i++) {
      let gwpCollectionForm = giftCollectionForm[i];
      
      gwpCollectionForm.addEventListener("submit", function (e) {
        e.preventDefault();
        let submitBtn = gwpCollectionForm.querySelector('input[type="submit"');
        let quantity = gwpCollectionForm.querySelector("input.quantity-selector").value;
        let id = gwpCollectionForm.querySelector("#product-id").value;
        
        if (quantity && id) {
          submitBtn.value = "Adding to cart"
          window.cart.add({ items: [{ "id": id, "quantity": quantity, properties: {'Free Gift': true, 'collection_property': true} }] }).then(()=>submitBtn.value = "Add to cart");
        }

        document.querySelector(".GWP-collection-wrapper").classList.add("hidden");
        submitBtn.setAttribute("disabled", "");
        setTimeout(function(){
          location.reload();
        }, 1000);
      });
    }
  }

  // GWP PRODUCT FORM LISTENER
  gwpProductForm() {
    let giftProductForm = document.querySelectorAll(this.selectors.giftProductForm);
    for (let i = 0; i < giftProductForm.length; i++) {
      let gwpProductForm = giftProductForm[i];
      
      gwpProductForm.addEventListener("submit", function (e) {
        e.preventDefault();
        let submitBtn = gwpProductForm.querySelector('input[type="submit"');
        let quantity = gwpProductForm.querySelector("input.quantity-selector").value;
        let id = gwpProductForm.querySelector("#product-id").value;
        
        if (quantity && id) {
          submitBtn.value = "Adding to cart"
          window.cart.add({ items: [{ "id": id, "quantity": quantity, properties: {'Free Gift': true, 'product_property': true} }] }).then(()=>submitBtn.value = "Add to cart");
        }

        document.querySelector(".GWP-product-wrapper").classList.add("hidden");
        submitBtn.setAttribute("disabled", "");
        setTimeout(function(){
          location.reload();
        }, 1000);
      });
    }
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (window.QF.settings.sideCart) {
      const openSideCart = e.target.closest(this.selectors.openSideCart);
      if (openSideCart) {
        e.preventDefault();
        window.cart.openSideCart();
      }
      const closeSideCart = e.target.closest(this.selectors.closeSideCart);
      if (closeSideCart) {
        e.preventDefault();
        window.cart.closeSideCart();
      }
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus)
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") == "true") return false;
      quantityPlus.setAttribute("data-pending", true);
      let quantity = quantityPlus.parentNode.querySelector(".quantity span");
      let stock = quantity.getAttribute("data-stock");
      let variant_id = quantity.getAttribute("data-variant-id");
      let inv_policy = quantity.getAttribute("data-inventory-policy");
      if (inv_policy == "continue" || stock > 0) {
        // if in stock or continue selling when out of stock, update cart
        window.cart.add({ items: [{ "id": variant_id, "quantity": quantity }] });
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus)
    if (quantityMinus) {
      
      let quantity = quantityMinus.parentNode.querySelector(".quantity span");
      let current = parseInt(quantity.innerHTML);
      let variant_id = quantity.getAttribute("data-variant-id");
      quantityMinus.setAttribute("data-pending", true);
      if (current > 1) {
        let updated = current - 1;
        window.cart.update({ updates: { [variant_id]: updated } });
      } else if (current == 1) {
        const cartItem = e.target.closest('.item');
        const removeItem = cartItem.querySelector('.remove-item');
        removeItem.click();
      }
    }
  }

  removeCartItem(e) {
    // REMOVE ITEM CART
    const removeButtons = e.target.closest(this.selectors.removeButtons)
    if (removeButtons) {
      const currentCartItem = removeButtons.closest('.item');
      let variant_id = currentCartItem.getAttribute("data-variant-id");
      let currentGroupId = currentCartItem.getAttribute('data-group-id');
      let arrayOfVariantId = [];

      window.cart.get().then((response)=>{
        const items = response.items;
        const currentItem = items.find((item)=> {
          if(item.variant_id == variant_id || item.properties['Group ID'] == currentGroupId) {
            return item
          }
        });
        if(currentItem) {
          if( currentItem.properties['Group ID'] != null ) {
            const groupid = currentItem.properties['Group ID'];
            arrayOfVariantId = items.map((item)=>{
              if(item.properties['Group ID'] === groupid ){
                return item.key
              }
            }).filter(Boolean)
          }
        }
        
        if(arrayOfVariantId.length >= 1) { 
          const cartForBlock = document.querySelector('#cart-drawer .inner')
          const cartForBlock2 = document.querySelector('#cart-container .cart')

          cartForBlock?.classList.add('loading');
          cartForBlock2?.classList.add('loading');
          currentCartItem.classList.add("item--loading");

          window.cart.removeBundle(arrayOfVariantId).then(()=>{
            window.cart.dispatchEvent("cart_changed", true);
            window.cart.dispatchEvent("item_removed", true);
            cartForBlock?.classList.remove('loading');
            cartForBlock2?.classList.remove('loading');
            window.cart.reRenderCartCounter();
          });
        } else {
          setTimeout(function(){
            window.cart.remove(variant_id)
          },  1000)
        }
      })
    }
  }

  removeCartItemAddOn(e) {
    // REMOVE ITEM CART
    const removeButtonsAddOn = e.target.closest(this.selectors.removeAddOnButtons)
    if (removeButtonsAddOn) {
      let variant_id = removeButtonsAddOn.getAttribute("data-variant-id");

      window.cart.get().then((response)=>{
        const items = response.items;
        const currentItem = items.find((item)=> {
          if(item.variant_id == variant_id) {
            return item
          }
        });
        

        setTimeout(function(){
          window.cart.remove(variant_id)
        },  1000)
      })
    }
  }

  cartRelated() {
    // update side cart/cart after change
    let renderCarts = () => {
      if (window.template == "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };

    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", (e) => {
      if (e.detail.cart) {
        let cartCount = document.querySelectorAll(".basket .site-header__badge");
        let counter = 0;
        let items = e.detail.cart.items
        
        items.forEach(el => {
          if(el && el.properties) {
            const hasProperties = !!Object.keys(el.properties).length
            if(hasProperties && el.properties['Group Type'] == 'Add-on'){}
            else{
              counter+=1;
            }
          }

        })
        if(counter > 0){
          cartCount.forEach((count) => {
            count.innerHTML = counter;
            count.classList.remove('is-hidden')
          })
        }else{
          cartCount.forEach((count) => {
            count.classList.add('is-hidden')
          })
        }
      }
    })
  }

  // HEADER SEARCH
  headerSearch(e) {
    const headerCont = document.querySelector('.header-container');
    const mainCont = document.querySelector('#MainContent');
    const search = document.querySelector('.mega-menu .header-left-bar .header-search-bar-wrapper');
    const searchTrigger = document.querySelector('.mega-menu .header-left-bar [data-open-search]');
    const searchInput = document.querySelector('.mega-menu .header-left-bar .header-search-bar-wrapper .search-bar-qf input');

    // Check Search exists
    if (search) {
      // Open / Close Search
      window.addEventListener('click', function (e) {
        let target = e.target;
        
        if (target.hasAttribute('data-open-search')) {
          if (target.classList.contains('active')) {
            // Return if active
            return;
          } else {
            // Open if not active
            headerCont.classList.add('search-active');
            mainCont.classList.add('search-open');
            searchTrigger.classList.add('active');
            search.classList.add('active');
            searchInput.focus();
          }
        } else if (target.classList.contains('header-search') || target.getAttribute('id') == 'submit_search') {

          // Do nothing if search is clicked
          return;
        } else {
          // Close if clicked off
          headerCont.classList.remove('search-active');
          mainCont.classList.remove('search-open');
          searchTrigger.classList.remove('active');
          search.classList.remove('active');
        }
      });

      // Close search with Escape Key
      window.addEventListener('keydown', function (e) {
        let key = e.key;

        if (key == 'Escape') {
          if (window.activeElement.classList.contains('header-search')) {
            headerCont.classList.remove('search-active');
            mainCont.classList.remove('search-open');
            searchTrigger.classList.remove('active');
            search.classList.remove('active');
          } else {
            return;
          }
        }
      });
    }

  }

  // MOBILE MENU
  mobileMenu(e) {
    const menu = document.querySelector('.mobile-menu-outer-wrapper');
    const menuTrigger = document.querySelector('#open-mobile-menu');
    const body = document.querySelector('body');

    if (menuTrigger) {
      menuTrigger.addEventListener('click', function () {
        if (menuTrigger.classList.contains('active')) {
          menu.classList.remove('active');
          menuTrigger.classList.remove('active');
          body.removeAttribute('style');
        } else {
          menu.classList.add('active');
          menuTrigger.classList.add('active');
          body.setAttribute('style', 'overflow: hidden;');
        }
      });
    }

    menu.addEventListener('click', function (e) {
      if (e.target.classList.contains('mobile-menu-outer-wrapper')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
        body.removeAttribute('style');
      }
    })

    const openSubmenuBtn = menu.querySelectorAll('.js-openSubmenu');
    const closeSubmenuBtn = menu.querySelectorAll('.js-closeSubmenu');

    openSubmenuBtn.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        btn.nextElementSibling.classList.toggle('active');
      })
    })

    closeSubmenuBtn.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        btn.closest('.js-submenu').classList.remove('active');
      })
    })

  }

  // MOBILE MENU
  stickyHeader(e) {
    const body = document.body;
    const header = document.getElementById('shopify-section-site-header');
    const counter = header.querySelector('.section_countdown');
    const headerTopLine = header.querySelector('.header-top-line');
    const main = document.getElementById('MainContent');
    let lastScroll = 30;

    let offset
    if(counter) {
      offset = headerTopLine.offsetHeight + counter.offsetHeight;
    } else {
      offset = headerTopLine.offsetHeight;
    }

    window.addEventListener('scroll', (e) => {

      const currentScroll = window.pageYOffset;
      if (currentScroll > lastScroll && lastScroll > 0) {
        header.classList.add('stuck');
        main.classList.add('headerStuck');
        if(counter) {
          if(window.innerWidth > 1023) {
            offset = headerTopLine.offsetHeight + counter.offsetHeight;
          } else {
            offset = counter.offsetHeight;
          }
        } else {
          if(window.innerWidth > 1023) {
            offset = headerTopLine.offsetHeight;
          } else {
            return
          }
        }
        header.setAttribute('style', `transform: translateY(${-offset}px)`)
      } else {
        lastScroll = currentScroll;
        header.removeAttribute('style');
        header.classList.remove('stuck');
        main.classList.remove('headerStuck');
      }

      lastScroll = currentScroll;
    });
  }

  pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
}

window.GlobalListeners = GlobalListeners;